import { LocationService } from './../../../shared/geolocation.service';
import { AfterViewInit, Component, Input, OnDestroy, OnInit, AfterContentInit, ViewChild } from '@angular/core';
import { FilterService } from '../../../shared/filter.service';
import { FilterType, Filter } from '../../../models/Filter';
import { Observable } from 'rxjs/Observable';
import { AppState } from '../../../models/app.state';
import { Store } from '@ngrx/store';
import { ICategoryState } from '../../../reducers/category.reducer';
import { Branch } from '../../../models/Branch';
import { Subscription } from 'rxjs/Subscription';
import { JqueryHelperService } from '../../../jquery-helper.service';
import { IProductsState } from "../../../reducers/product.reducer";
import { IonRangeSliderComponent } from "ng2-ion-range-slider";
// import { IonRangeSliderComponent } from "ng2-ion-range-slider";
declare let $: any;


@Component({
  selector: 'ciu-productfilter',
  templateUrl: './productfilter.component.html',
  styleUrls: ['./productfilter.component.css']
})
export class ProductfilterComponent implements OnInit, OnDestroy, AfterViewInit, AfterContentInit {
  @ViewChild('rangeSliderElement') rangeSliderElement: IonRangeSliderComponent;
  @ViewChild('singleSlider') singleSlider: IonRangeSliderComponent;

  constructor(private filterService: FilterService,
    private store: Store<AppState>,
    public jqueryService: JqueryHelperService,
    public locationService: LocationService) {
    this.currentLang = this.store.select('lang');
    this.branches$ = this.store.select('categoriesState');

  }
  @Input()
  isMobile = false;

  branches$: Observable<ICategoryState>;
  currentLang: Observable<string>;
  loading = false;
  branches: string[];
  locationAllowed = false;
  location: any;
  branchSubscription: Subscription = new Subscription();
  idExtension: string;
  tags: Array<string> = ['Female', 'Male', 'Kids'];

  ngOnInit() {
    this.jqueryService.overlayTouchmove();
    this.idExtension = this.isMobile ? 'mobile' : 'desktop';

    const sub = this.currentLang.subscribe((lang) => {
      this.getCategories(lang);
    });

    this.branchSubscription.add(sub);
    this.jqueryService.sliderStep();
  }

  getLocation() {
    if (!this.locationService.userCoords) {
      if (navigator.geolocation) {
        console.log('NAVIGATOR');
        navigator.geolocation.getCurrentPosition(position => {
          console.log('CURRENT POSITION: ', position.coords);
          this.locationAllowed = true;
          this.location = position.coords;
          this.locationService.userCoords = position.coords;
          // this.jqueryService.initDistanceSlider('desktop');
          // this.jqueryService.initDistanceSlider('mobile');
        });

      }
    }
  }

  getCategories(lang) {
    const sub = this.branches$
      .subscribe((categoryState: ICategoryState) => {
        this.loading = categoryState.loading;
        this.branches = categoryState.categories.map((category: Branch) => category[lang]);
      });
    this.branchSubscription.add(sub);
  }

  onAddCategoryFilter(categoryName: string) {
    this.filterService.addFilter(categoryName, FilterType.CATEGORY);
  }

  onAddTagFilter(tag: string) {
    this.filterService.addFilter(tag, FilterType.TAG);
  }

  ngOnDestroy(): void {
    this.branchSubscription.unsubscribe();
  }

  ngAfterViewInit(): void {
    // this.jqueryService.changeSlider(this.idExtension);
  }

  ngAfterContentInit(): void {
    this.jqueryService.changeSlider2(this.rangeSliderElement, this.singleSlider, this.idExtension);
  }

}



// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/container/products-and-filter/productfilter/productfilter.component.ts